import React from 'react';
import HeaderSection from "../headerSection/HeaderSection";

 function ShrineCalendar() {
  return (
    <div>
      <HeaderSection></HeaderSection>

<p>تقویم حرم</p>
    </div>
  )
}
export default ShrineCalendar;

